/** @internal */
export const OP_CONTINUE = "Continue" as const

/** @internal */
export type OP_CONTINUE = typeof OP_CONTINUE

/** @internal */
export const OP_CLOSE = "Close" as const

/** @internal */
export type OP_CLOSE = typeof OP_CLOSE

/** @internal */
export const OP_YIELD = "Yield" as const

/** @internal */
export type OP_YIELD = typeof OP_YIELD
